import { Box, Grid, Paper, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import { ActionMsg, AddButton, Breadcrumb, CustomePopover, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleCloseSnackbar, HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
import { rows } from './../MastersFakeDb';
import { editDeleteDriver, getDriverList } from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import driverMasterService from "../../../services/masters/driverMaster.Service"
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";

const DriverList = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [sortBy, setSortBy] = useState(null);
    const totalCount = useSelector(state => state.driver.total_count || 0);
    const defaultRowsPerPage = useSelector(state => state.driver.rows_per_page || 15);
    // const rows = useSelector(state => state.driver.driver)
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    const fields = ['driver_name', "driver_address", "driver_contact_no","driving_license_validity","driving_license_no"];
    const labels = ['Driver Name', "Address", "	Contact No","Driving License Validity","Driving License No"];

    // const [successMessage, setSuccessMessage] = useState(null);
    // const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.charges.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage
    });
    useEffect(() => {
        setController(prev => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);


    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage
        });
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };


    // const handleSearch = (e) => {
    //     setSearchKey(e.target.value)
    //     const params = {
    //         page: controller.page,
    //         size: e.target.value === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
    //         searchKey: e.target.value,
    //     }
    //     dispatch(getDriverList(params))
    // }
    const handleSearch = async (e) => {
        const searchValue = e.target.value;
        setSearchKey(searchValue);  // Set the search key

        // Prepare the params based on the search value
        const params = {
            page: controller.page,
            size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
            searchKey: searchValue,
        };

        try {
            // Fetch data using the fetchData function (assuming fetchData is already declared)
            await fetchData(params);
        } catch (error) {
            console.error("Error in handleSearch:", error);
        }
    };


    const fetchData = async () => {
        try {
            const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            }
            const response = await driverMasterService.getDriverList(params);
            setRows(response);
        }
        catch (error) {
            console.error("Error fetching data:", error);
            setSuccessMessage("Error fetching data");
        }
    };

    useEffect(() => {
        fetchData()
    }, [controller]);

    // const { shouldShowMsg, responseMessage } = useMessageHandler( null, setSuccessMessage, respMsgState);

    // useEffect(() => {
    // }, [shouldShowMsg, responseMessage,]);





    const deleteRecord = async (id) => {
        try {
            await driverMasterService.editDeleteDriver({
                driver_id: id,
                changedUpdatedValue: "delete"
            });
            setIsDelete(false);
            fetchData();
            setSuccessMessage("Record deleted successfully");
        } catch (error) {
            setSuccessMessage("Error deleting record");
        }
    };

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
    };

    const [successMessage, setSuccessMessage] = useState(null);
    //const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.driver.message);

    // const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);
    // useEffect(() => {
    //     if (respMsgState) {
    //         setSuccessMessage(respMsgState);
    //     }
    // }, [respMsgState]);
    // useEffect(() => {
    // }, [shouldShowMsg, responseMessage,]);





    // Sort rows by entry_date descending
    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
    // Calculate pagination info
     const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

    console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });



    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb
                    routeSegments={[
                        // { name: 'Dashbord', path: '/dashboard' },
                        { name: 'Drivers List' },
                    ]}
                />



                <HeaderSection
                    title="DRIVER LIST"
                    addNewPath="/masters/add-driver"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Driver List"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />



                <Paper sx={{ width: '100%',  }}>
                    <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell className={`${styles.table_head}`}
                                        sx={{ width: '15%' }} align="left" onClick={() => HandleSort('driver_name', sortBy, setSortBy, rows)}>Driver Name<span className={`${styles.sort_icon}`}> {sortBy === 'driver_name' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`}
                                        sx={{ width: '20%' }}
                                        onClick={() => HandleSort('driver_address', sortBy, setSortBy, rows)}>Address<span className={`${styles.sort_icon}`}> {sortBy === 'driver_address' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`}>
                                        Contact No
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort('driving_license_validity', sortBy, setSortBy, rows)}>Driving License Validity<span className={`${styles.sort_icon}`}> {sortBy === 'driving_license_validity' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort('driving_license_no', sortBy, setSortBy, rows)}>Driving License No<span className={`${styles.sort_icon}`}> {sortBy === 'driving_license_no' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: '#fff' }}>
                                {Array.isArray(rows) && rows.map((row, index) => (
                                    <StyledTableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.driver_name}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.driver_address}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.driver_contact_no}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.driving_license_validity}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.driving_license_no}</StyledTableCell>

                                        <StyledTableCell align="center">
                                            <CustomePopover row={row}     handleCancel={false} handleDelete={false} linkTo="/masters/add-driver"   handlePrint ={false}/>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                              <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
                </Paper>

                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.driver_id || null}
                    displayName={deleteInfo?.driver_name || ''}
                />
                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    )
}
export default DriverList;